import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const DeactivateIcon = ({ width = 18, height = 18, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.3346 4.39664V3.42248V2.44832V0.5H7.59265V4.39664H6.22168L8.96361 7.96115L11.7055 4.39664H10.3346Z'
        fill={hovered ? 'white' : 'none'}
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      {hovered && (
        <path
          d='M7.33365 9.94379H15.8337L15.8187 17.5H7.31866H2.10853L2.12353 9.94379L0.5 7.23449H5.70968L7.33365 9.94379Z'
          fill={fill}
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      )}
      <path d='M15.8336 9.9438L17.4996 7.23451H12.29L10.7857 9.9438' fill={hovered ? 'white' : 'none'} />
      <path
        d='M7.33365 9.9438H15.8337M7.33365 9.9438L7.31866 17.5M7.33365 9.9438L5.70968 7.2345H0.5L2.12353 9.9438L2.10853 17.5H7.31866M7.33365 9.9438H4.31752M15.8337 9.9438L15.8187 17.5H7.31866M15.8337 9.9438L17.4997 7.23451H12.29L11.7822 8.13356'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.2534 15.8548H14.1728M12.8018 14.1493H14.1728'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
